'use client';

import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth';
import { isImpersonationActive } from '@/lib/impersonation';
import type { Membership } from '@/stores/auth';

function fullUserName(user: { firstName: string; lastName: string; email: string } | null): string {
  if (!user) return '';
  const trimmed = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
  return trimmed || user.email;
}

function roleLabel(m: Membership | null): string {
  if (!m) return '—';
  return m.role.charAt(0) + m.role.slice(1).toLowerCase();
}

function workspaceLabel(m: Membership | null): string {
  return m?.dealership.name ?? 'No workspace selected';
}

export function ImpersonationBanner() {
  const [mounted, setMounted] = useState(false);
  const user = useAuthStore((s) => s.user);
  const activeMembership = useAuthStore((s) => s.activeMembership());

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !isImpersonationActive() || !user) {
    return null;
  }

  const name = fullUserName(user);
  const role = roleLabel(activeMembership);
  const workspace = workspaceLabel(activeMembership);

  return (
    <div
      role="status"
      className="sticky top-0 z-[100] w-full border-b border-orange-600 bg-orange-500 px-4 py-2 text-center text-sm font-medium text-white shadow-sm"
    >
      You are currently impersonating user {name}, {role} at {workspace}.
    </div>
  );
}
